import { fechaEvaluacionApi } from "../view/fecha_evaluacion.service";

export const createFechaEvaluacionEntity = fechaEvaluacionApi.injectEndpoints({
  endpoints: (builder) => ({
    createFechaEvaluacionEntity: builder.mutation({
      query: (body) => ({
        url: "/v1/api/permisoevaluacion/entity/",
        method: "POST",
        body: body,
      }),
      providesTags: (result) =>
        Array.isArray(result)
          ? [
              ...result.map(({ id }) => ({
                type: "Fecha Evaluacion",
                id,
              })),
              { type: "Fecha Evaluacion", id: "LIST" },
            ]
          : [{ type: "Fecha Evaluacion", id: "LIST" }],
    }),
  }),
});

export const { useCreateFechaEvaluacionEntityMutation } =
  createFechaEvaluacionEntity;
